import React from "react";

class GalleryItem extends React.Component{
    constructor(props) {
        super(props)
        this.state = { imgError: false };
        this.imgRef = null;
        this.item = this.props.item;
    }

    componentDidMount() {
        if (this.imgRef && this.imgRef.complete && this.imgRef.naturalHeight === 0) {
            this.handleImageError();
        }
    }

    handleImageError = () => {
        this.setState({ imgError: true });
    }

    render(){
        const { item, baseImageUrl } = this.props;
        const { imgError } = this.state;
        let imageUrl = baseImageUrl + "/" + item.image + "?width=500";
        let detailUrl = "/Custom-Option/Finish/Detail/" + encodeURIComponent(item.sku);
        return(
            <gallery-item>
                <a href={detailUrl} className="image-container">
                    {!imgError ? (
                        <img ref={el => this.imgRef = el} src={imageUrl} alt={item.name} className="lazy-image gallery-item-image" onError={this.handleImageError} />
                    ) : (
                        <div className="gallery-item-placeholder"><image-placeholder></image-placeholder></div>
                    )}
                </a>
                <a href={detailUrl} className="gallery-item-info">
                    <span className="gallery-item-title">{item.sku}</span>
                    {item.subOptionCode && <span className="gallery-item-grade">{item.subOptionCode}</span>}
                    <div className="gallery-item-actions">
                        <div className="gallery-item-like">
                            <img src="/images/icons/heart-icon.png" alt="Like" onClick={(e)=>this.props.onLike(e,item)} />
                        </div>
                        <div className="gallery-item-cart" title="Add to Sample Cart">
                            <img src="/images/icons/cart-icon.svg" alt="Add to Sample Cart" onClick={(e)=>{
                                e.preventDefault();
                                e.stopPropagation();
                                document.dispatchEvent(new CustomEvent('post-fabric-cart-item', {
                                    detail: { sku: item.sku, name: item.name || item.sku }
                                }));
                            }} />
                        </div>
                    </div>
                </a>
            </gallery-item>
        );
    }

}

export class ShoppingGallery extends React.Component{
    constructor(props) {
        super(props)
    }

    get items(){
        let data=this.props.data;
        return data.map((item)=>{
           return <GalleryItem key={item.id} item={item} baseImageUrl={this.props.baseImageUrl} onLike={this.props.onLike} />
        });
    }

    render(){
        return(
            <shopping-gallery className="finishes">
                {this.items}
            </shopping-gallery>
        );

    }
}
